import { FormControl } from '@angular/forms';
import { EntityReference } from '../../core/entities/shared/entity-reference.entity';
import { positiveNotNull, positiveOrZero, requiredNotNull } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export class ShoppingItemFormControls extends BaseFormControls {
  amount = new FormControl(1, positiveNotNull);
  bestBeforeDate = new FormControl<Date | null>(new Date());
  location = new FormControl<EntityReference | null>(null, requiredNotNull);
  neverOverdue = new FormControl(true, requiredNotNull);
  pantIncluded = new FormControl(false, requiredNotNull);
  purchaseQuPant = new FormControl<number | null>(null, positiveOrZero);
  purchaseQuPrice = new FormControl<number | null>(null, positiveOrZero);
  totalDiscount = new FormControl<number | null>(null, positiveOrZero);
}
